import { Customer } from '../types';

const makeCustomersFormat = (response: { Data?: Record<string, unknown>[] } | Record<string, unknown>[]): Customer[] => {
  const raw = Array.isArray(response) ? response : response?.Data || [];
  return raw.map((c) => ({
    Id: Number(c.Id) || 0,
    Name: String(c.Name || ''),
    TypeId: Number(c.TypeId) || 0,
    TypeTitle: String(c.TypeTitle || ''),
    Address: String(c.Address || ''),
    WorkPhone: String(c.Phone || c.WorkPhone || ''),
    CellPhone: String(c.CellPhone || ''),
    HomePhone: String(c.HomePhone || ''),
    WorkEmail: String(c.Email || c.WorkEmail || ''),
    PersonalEmail: String(c.PersonalEmail || ''),
    OtherEmail: String(c.OtherEmail || ''),
    UpdatedOn: String(c.UpdatedOn || ''),
    NumberOfCases: Number(c.NumberOfCases) || 0,
    NumberOfContacts: Number(c.NumberOfContacts) || 0,
    NumberOfActivities: Number(c.NumberOfActivities) || 0,
  }));
};

export default makeCustomersFormat;
